import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/CoursesOffered.css";
import { Zap, Cable, Hammer, Loader2 } from "lucide-react"; // icons

const API_URL = "https://auxititpt.org/Backend/trade_api.php";

const CoursesOffered = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Fetch trades from DB
  useEffect(() => {
    const fetchTrades = async () => {
      try {
        const res = await fetch(API_URL);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (!Array.isArray(data)) throw new Error("Invalid API response");
        setCourses(data);
      } catch (err) {
        console.error("Fetch trades error:", err);
        setError("Failed to load courses. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchTrades();
  }, []);

  // Icon selector for trade name
  const getTradeIcon = (tradeName) => {
    const name = tradeName?.toLowerCase() || "";
    if (name.includes("welder")) return <Hammer className="icon" />;
    if (name.includes("wireman")) return <Cable className="icon" />;
    if (name.includes("electrician")) return <Zap className="icon" />;
    // Default icon
    return <Hammer className="icon" />;
  };

  return (
    <section className="courses-section py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">Courses Offered</h2>
          <p className="section-subtitle">
            Explore our NCVT-approved trades designed to provide quality technical education.
          </p>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <Loader2 className="animate-spin text-primary" size={40} />
            <p className="mt-2 text-muted">Loading courses...</p>
          </div>
        ) : error ? (
          <div className="alert alert-danger text-center">{error}</div>
        ) : courses.length === 0 ? (
          <div className="text-center text-muted fs-5">No courses found.</div>
        ) : (
          <div className="row g-4">
            {courses.map((course, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="course-card">
                  {/* <div className="course-icon">{getTradeIcon(course.trade_name)}</div> */}
                  <h4>{course.trade_name}</h4>
                  <p className="approval">{course.approved_by }</p>

                  <ul className="course-details list-unstyled text-start mt-3">
                    <li>
                      <strong>Trade Duration:</strong>{" "}
                      {course.duration ? course.duration : "—"}
                    </li>
                    <li>
                      <strong>Syllabus:</strong>{" "}
                      {course.syllabus_url ? (
                        <a
                          href={course.syllabus_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Here
                        </a>
                      ) : (
                        "—"
                      )}
                    </li>
                    <li>
                      <strong>Minimum Qualification:</strong>{" "}
                      {course.qualification ? course.qualification : "—"}
                    </li>
                    <li>
                      <strong>Trade Type:</strong> Engineering
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default CoursesOffered;